import type { CaseView } from '@chemoflow/contracts';

/** 「戻す」で一緒に消える記録の順。確定済みHTMLの LATER と同じ。 */
const LATER = [
  ['pharm', '調製開始'],
  ['pharmDone', '調製完了'],
  ['admin', '投与開始'],
  ['adminDone', '投与完了'],
] as const;

type Stage = (typeof LATER)[number][0];

/**
 * from 以降で、実際に記録がある段だけを「・」でつなぐ。
 * 確認の文言に、実際に消えるものだけを並べるために使う（例：調製開始・調製完了・投与開始）。
 */
export function laterRecords(c: CaseView, from: Stage): string {
  const start = LATER.findIndex(([k]) => k === from);
  return LATER.slice(start)
    .filter(([k]) => c[k])
    .map(([, label]) => label)
    .join('・');
}

/** 化学療法室でどこまで進んでいるか（確認の見出しに使う）。 */
export const nurseStage = (c: CaseView): string => (c.adminDone ? '投与完了' : '投与開始');
